import React from 'react';
import { graphql, Link as GatsbyLink } from 'gatsby';
import styled from 'styled-components';
import { buildUrl } from '../../utils';

const StyledLinkInternal = styled(GatsbyLink)``;

const StyledLinkExternal = styled.a``;

export const Link = ({ to, children, ...props }) => {
  const isExternal = to.url;
  const LinkComponent = isExternal ? StyledLinkExternal : StyledLinkInternal;
  const slug = typeof to === 'string' ? to : to && to.slug;

  return (
    <LinkComponent
      {...(isExternal
        ? {
            href: to.url,
            target: to.openLinkInNewWindow ? '_blank' : undefined,
            rel: 'noopener',
          }
        : {
            to: slug === '/' ? slug : buildUrl(slug, to),
          })}
      {...props}
    >
      {children}
    </LinkComponent>
  );
};

export const LinkFragment = graphql`
  fragment LinkFragment on Node {
    ... on DatoCmsHome {
      slug
    }
    ... on DatoCmsPage {
      slug
      treeParent {
        slug
        treeParent {
          slug
          treeParent {
            slug
          }
        }
      }
    }
    ... on DatoCmsFeaturesListing {
      slug
    }
    ... on DatoCmsFeatureCategory {
      slug
      internal {
        type
      }
    }
    ... on DatoCmsFeature {
      slug
      category {
        slug
      }
      internal {
        type
      }
    }
    ... on DatoCmsCaseStudyListing {
      slug
    }
    ... on DatoCmsCaseStudy {
      slug
      internal {
        type
      }
    }
    ... on DatoCmsBlogListing {
      slug
    }
    ... on DatoCmsBlog {
      slug
      internal {
        type
      }
    }
    ... on DatoCmsDemo {
      slug
    }
    ... on DatoCmsExternalUrl {
      url
      openLinkInNewWindow
    }
  }
`;
